var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',{staticClass:"manager-main"},[_c('SectionList'),_c('Summary')],1)}
var staticRenderFns = []

export { render, staticRenderFns }